module.exports = __webpack_public_path__ + "0b3d4570aab30e34dab2c78905388e02.pdf";